import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  lazy,
  useMemo,
  Suspense,
} from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation, useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import {
  // halteTableData,
  halteTableTitle,
  halteTableTitleAfter,
  previousAnalysisData,
  previousAnalysisTitle,
  TSRTableData,
  TSRTableTitle,
  speedTestTableTitle,
  speedTestTableData,
} from "../utils/tableData";
import { apiService } from "../utils/apiService";
import RAILWAY_CONST from "../utils/RailwayConst";
import ChartComponent from "./ChartComponent";
import {
  getDataFromLocalStorage,
  setDataOnLocalStorage,
} from "../utils/localStorage";
import ShowMessagePopUp from "./ShowMessagePopUp";

// Lazy load components
const ReportTable = lazy(() => import("./ReportTable"));
const TableComponent = lazy(() => import("./TableComponent"));
const SpeedGraphComponent = lazy(() => import("./SpeedGraphComponent"));
const DeficiencyRemark = lazy(() => import("./DeficiencyRemark"));
const Loader = lazy(() => import("./Loader"));
const UploadFilePopup = lazy(() => import("./UploadFilePopup"));

const ReportGenerateComponent = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { deficiency, remark } = location.state || {};
  // const [currentReport, setCurrentReport] = useState(
  //   getDataFromLocalStorage("currentReport")
  // );
  const [currentReport, setCurrentReport] = useState(null);
  const contentRef = useRef(null);
  const [haltStation, setHaltStation] = useState({});
  const [fullFormData, setFullFormData] = useState({
    id: id,
    train_id: "",
    load: "",
    bmbs: "",
    loco_no: "",
    spm: "",
    deficiency: "",
    remark: "",
  });
  const [showUploadBox, setShowUploadBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [halteTableData, setHalteTableData] = useState(null);
  const [halteTableDataAfter, setHalteTableDataAfter] = useState(null);
  const [chartSpeedBeforHaltData, setChartSpeedBeforHaltData] = useState(null);
  const [chartSpeedAfterHaltData, setChartSpeedAfterHaltData] = useState(null);


  const [formData, setFormData] = useState({
    dateofWorking: "",
    trainNo: "",
  });
  const [popup, setPopup] = useState({ show: false, message: "", type: "" });
  const [error, setError] = useState("");

  const handleFormChange = useCallback((updatedData) => {
    setFormData((prev) => ({ ...prev, ...updatedData }));
  }, []);

  // const handleDownloadPDF = async () => {
  //   setLoading(true);
  //   console.log("loading");
  //   if (contentRef.current) {
  //     const input = contentRef.current;
  //     const downloadButton = document.getElementById("downloadPdfButton");
  //     if (downloadButton) downloadButton.style.display = "none";

  //     const boderBottom = document.getElementById("sectionTitle");
  //     if (boderBottom) boderBottom.classList.remove("border-b");

  //     const backButton = document.getElementById("backButton");
  //     if (backButton) backButton.style.display = "none";
  //     const submitButon = document.getElementById("submitButon");
  //     if (submitButon) submitButon.style.display = "none";
  //     const pdfLogo = document.getElementById("pdfLogo");
  //     if (pdfLogo) pdfLogo.style.display = "flex";
  //     document.querySelectorAll("input, select, textarea").forEach((el) => {
  //       el.style.border = "0";
  //       if (el.hasAttribute("readonly")) {
  //         el.style.background = "white";
  //       }
  //     });

  //     html2canvas(input, { scale: 2, useCORS: true, logging: false }).then(
  //       (canvas) => {
  //         const imgData = canvas.toDataURL("image/png");
  //         const pdf = new jsPDF("p", "mm", "a4");

  //         let position = 0;
  //         let remainingHeight = (canvas.height * 210) / canvas.width;

  //         while (remainingHeight > 0) {
  //           pdf.addImage(
  //             imgData,
  //             "PNG",
  //             0,
  //             position,
  //             210,
  //             (canvas.height * 210) / canvas.width
  //           );
  //           remainingHeight -= 297;
  //           position -= 297;
  //           if (remainingHeight > 0) pdf.addPage();
  //         }

  //         pdf.save("download.pdf");
  //         setLoading(false);
  //         if (downloadButton) downloadButton.style.display = "block";
  //         if (pdfLogo) pdfLogo.style.display = "none";
  //         if (backButton) backButton.style.display = "inline-block";
  //         if (submitButon) submitButon.style.display = "inline-block";
  //         if (boderBottom) boderBottom.classList.add("border-b");
  //         document.querySelectorAll("input, select, textarea").forEach((el) => {
  //           el.style.border = "1px solid #e5e7eb";
  //           if (el.hasAttribute("readonly")) {
  //             el.style.background = "#f3f4f6";
  //           }
  //         });
  //       }
  //     );
  //   }
  //   //  setLoading(false);
  // };

  useEffect(() => {
    // const fetchReportById = async () => {
    //   setLoading(true);
    //   try {
    //     const response = await apiService("get", RAILWAY_CONST.API_ENDPOINT.REPORTS_SLASH);
    //     // console.log("Response Data:", response.data);
    //     const reports = Array.isArray(response.data)
    //       ? response.data
    //       : response.reports || [];
    //     // console.log("Reports:", reports,reports.id, id);

    //     const matchedReport = reports.find((report) => String(report?.id) === String(id));
    //     // console.log("Matched Report:", matchedReport);
    //     if (matchedReport) {
    //       setCurrentReport(matchedReport);
    //     } else {
    //       console.warn("No report found with id:", id);
    //       setCurrentReport(null); // Or handle gracefully
    //     }
    //   } catch (error) {
    //     console.error("Error fetching reports:", error);
    //   } finally {
    //     setLoading(false);
    //   }
    // };
    const fetchReportById = async () => {
      setLoading(true);
      try {
        const response = await apiService(
          "get",
          `${RAILWAY_CONST.API_ENDPOINT.REPORTS_SLASH}${id}`
        );
    
        setCurrentReport(response.data);
    
      } catch (error) {
        console.error("Error fetching report:", error);
        setCurrentReport(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchReportById();
    }
  }, [id]);

  // if (!currentReport) {
  //     return <div>Loading report...</div>;
  //   }


  const handleDownloadPDF = async () => {
    setLoading(true);
    const downloadButton = document.getElementById("downloadPdfButton");
    const borderBottom = document.getElementById("sectionTitle");
    const backButton = document.getElementById("backButton");
    const submitButton = document.getElementById("submitButon");
    const pdfLogo = document.getElementById("pdfLogo");
    const grayBgDivs = document.querySelectorAll(".grayBg");

    // Hide/show elements
    if (downloadButton) downloadButton.style.display = "none";
    if (borderBottom) borderBottom.classList.remove("border-b");
    if (backButton) backButton.style.display = "none";
    if (submitButton) submitButton.style.display = "none";
    if (pdfLogo) pdfLogo.style.display = "flex";

    grayBgDivs.forEach((div) => {
      div.classList.remove("bg-gray-100");
    });

    // Store original textareas and replace with divs
    const textareaReplacements = [];
    document.querySelectorAll("textarea").forEach((textarea) => {
      // Store the original textarea reference
      textareaReplacements.push({
        original: textarea,
        parent: textarea.parentNode,
        nextSibling: textarea.nextSibling,
      });

      // Create replacement div
      const div = document.createElement("div");
      div.textContent = textarea.value;
      div.style.whiteSpace = "pre-wrap";
      div.style.padding = "8px";
      div.style.borderRadius = "4px";
      //div.style.border = "1px solid #e5e7eb"; // Match textarea border
      div.style.minHeight = "100px"; // Match typical textarea height
      div.style.width = "100%"; // Match textarea width

      // Replace textarea with div
      textarea.parentNode.replaceChild(div, textarea);
    });

    document.querySelectorAll("input, select, textarea").forEach((el) => {
      el.style.border = "0";
      if (el.hasAttribute("readonly")) {
        el.style.background = "white";
      }
    });

    const pdf = new jsPDF("p", "mm", "a4");

    try {
      const firstPart = document.getElementById("pdf-first-part");
      const speedGraphPart = document.getElementById("pdf-speed-graph");

      if (firstPart) {
        const canvas1 = await html2canvas(firstPart, {
          scale: 2,
          useCORS: true,
          logging: false,
        });
        const imgData1 = canvas1.toDataURL("image/png");

        pdf.addImage(
          imgData1,
          "PNG",
          0,
          0,
          210,
          (canvas1.height * 210) / canvas1.width
        );
      }

      if (speedGraphPart) {
        pdf.addPage();
        const canvas2 = await html2canvas(speedGraphPart, {
          scale: 2,
          useCORS: true,
          logging: false,
        });
        const imgData2 = canvas2.toDataURL("image/png");

        pdf.addImage(
          imgData2,
          "PNG",
          0,
          0,
          210,
          (canvas2.height * 210) / canvas2.width
        );
      }

      pdf.save("download.pdf");
    } catch (error) {
      console.error("PDF generation error:", error);
    } finally {
      // Restore original textareas
      textareaReplacements.forEach(({ original, parent, nextSibling }) => {
        const currentDiv = parent.querySelector("div");
        if (currentDiv) {
          if (nextSibling) {
            parent.insertBefore(original, nextSibling);
          } else {
            parent.appendChild(original);
          }
          parent.removeChild(currentDiv);
        }
      });

      setLoading(false);

      if (downloadButton) downloadButton.style.display = "block";
      if (borderBottom) borderBottom.classList.add("border-b");
      if (backButton) backButton.style.display = "inline-block";
      if (submitButton) submitButton.style.display = "inline-block";
      if (pdfLogo) pdfLogo.style.display = "none";

      grayBgDivs.forEach((div) => {
        div.classList.add("bg-gray-100");
      });

      document.querySelectorAll("input, select, textarea").forEach((el) => {
        el.style.border = "1px solid #e5e7eb";
        if (el.hasAttribute("readonly")) {
          el.style.background = "#f3f4f6";
        }
      });
    }
  };

  const halteTable = useMemo(
    () => ({ data: halteTableData, columns: halteTableTitle }),
    [halteTableData, halteTableTitle]
  );


  const halteTableAfter = useMemo(
    () => ({ data: halteTableDataAfter, columns: halteTableTitleAfter }),
    [halteTableDataAfter, halteTableTitleAfter]
  );


  const previousAnalysis = useMemo(
    () => ({ data: previousAnalysisData, columns: previousAnalysisTitle }),
    []
  );

  const TSRTable = useMemo(
    () => ({ data: TSRTableData, columns: TSRTableTitle }),
    []
  );

  const speedTestTable = useMemo(
    () => ({ data: speedTestTableData, columns: speedTestTableTitle }),
    []
  );

  // useEffect(() => {
  //   const fetchHaltData = async () => {
  //     await getHaltTableData(false);
  //   };
  //   fetchHaltData();
  // }, []);

  // useEffect(() => {
  //   getHaltTableData(true);
  // }, [haltStation]);

  useEffect(() => {
    getHaltTableData(!!haltStation?.from && !!haltStation?.to);
    getHaltTableDataAfter(!!haltStation?.from && !!haltStation?.to);
  }, [haltStation]);

  // useEffect(() => {
  //   getHaltTableDataAfter(!!haltStation?.from && !!haltStation?.to);
  // }, [haltStation]);

  const getHaltTableData = async (limitedHaltStation) => {
    // if (currentReport?.speed_before_1000m) {

    // }
    const url =
      limitedHaltStation && haltStation && haltStation.from && haltStation.to
        ? `${RAILWAY_CONST.API_ENDPOINT.REPORTS}/${id}${RAILWAY_CONST.API_ENDPOINT.STAT_SPEED_BEFORE_HALT}?from_station=${haltStation.from}&to_station=${haltStation.to}`
        : `${RAILWAY_CONST.API_ENDPOINT.REPORTS}/${id}${RAILWAY_CONST.API_ENDPOINT.STAT_SPEED_BEFORE_HALT}`;
    try {
      const response = await apiService("get", url);
      setHalteTableData(response.data);
      // console.log("Response Data Before:", response.data);
      // setDataOnLocalStorage("reportList", response);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  const getHaltTableDataAfter = async (limitedHaltStation) => {
    // if (currentReport?.speed_before_1000m) {

    // }
    const url =
      limitedHaltStation && haltStation && haltStation.from && haltStation.to
        ? `${RAILWAY_CONST.API_ENDPOINT.REPORTS}/${id}${RAILWAY_CONST.API_ENDPOINT.STAT_SPEED_AFTER_HALT}?from_station=${haltStation.from}&to_station=${haltStation.to}`
        : `${RAILWAY_CONST.API_ENDPOINT.REPORTS}/${id}${RAILWAY_CONST.API_ENDPOINT.STAT_SPEED_AFTER_HALT}`;
    try {
      const response = await apiService("get", url);
      setHalteTableDataAfter(response.data);
      // console.log("Response Data After:", response.data);
      // setDataOnLocalStorage("reportList", response);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  const getChartSpeedBeforeHaltData = async (limitedHaltStation) => {
    // if (!speed_before_1000m) {
    //   console.warn("No  API call.");
    //   return;
    // }

    const url =
      limitedHaltStation && haltStation?.from && haltStation?.to
        ? `${RAILWAY_CONST.API_ENDPOINT.REPORTS}/${id}${RAILWAY_CONST.API_ENDPOINT.SPEED_BEFORE_HALT}?from_station=${haltStation.from}&to_station=${haltStation.to}`
        : `${RAILWAY_CONST.API_ENDPOINT.REPORTS}/${id}${RAILWAY_CONST.API_ENDPOINT.SPEED_BEFORE_HALT}`;

    try {
      const response = await apiService("get", url);

      setChartSpeedBeforHaltData(JSON.parse(response.data));
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  const getChartSpeedAfterHaltData = async (limitedHaltStation) => {
    // if (!speed_before_1000m) {
    //   console.warn("No  API call.");
    //   return;
    // }

    const url =
      limitedHaltStation && haltStation?.from && haltStation?.to
        ? `${RAILWAY_CONST.API_ENDPOINT.REPORTS}/${id}${RAILWAY_CONST.API_ENDPOINT.SPEED_AFTER_HALT}?from_station=${haltStation.from}&to_station=${haltStation.to}`
        : `${RAILWAY_CONST.API_ENDPOINT.REPORTS}/${id}${RAILWAY_CONST.API_ENDPOINT.SPEED_AFTER_HALT}`;

    try {
      const response = await apiService("get", url);

      setChartSpeedAfterHaltData(JSON.parse(response.data));
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  useEffect(() => {
    fetchData(!!haltStation?.from && !!haltStation?.to);
  }, [haltStation,halteTableData, halteTableDataAfter]);

  const fetchData = async (limitedHaltStation) => {
    setLoading(true);
    if (halteTableData) {
      // console.log(halteTableData, "halttable")
      await getChartSpeedBeforeHaltData(limitedHaltStation);
    }
    if (halteTableDataAfter) {
      // console.log(halteTableDataAfter, "halttableAfter")
      await getChartSpeedAfterHaltData(limitedHaltStation);
    }
    setLoading(false);
  };

  const handleHaltSelectedData = (fromStation, toStation) => {
    setHaltStation({ from: fromStation, to: toStation });
  };

  const handleformData = (data, label) => {
    if (label === "allFields") {
      setFullFormData((prev) => ({
        ...prev,
        title: data.title || prev.title,
        train_id: data.trainNo || prev.train_id,
        load: data.load || prev.load,
        bmbs: data.bmbs || prev.bmbs,
        loco_no: data.locoNo || prev.loco_no,
        spm: data.spm || prev.spm,
        analyzed_by: data.analyzedBy || prev.analyzed_by,
        lp_cms_id: data.lpCMSID || prev.lp_cms_id,
        nominated_cli: data.nominatedCLI || prev.nominated_cli,
        crew_designation: data.designation || prev.crew_designation,
        crew_name: data.lp || prev.crew_name,
        alp_cms_id: data.alpCMSID || prev.alp_cms_id,
        alp_nominated_cli: data.alpNominatedCLI || prev.alp_nominated_cli,
        alp_crew_designation: data.alpDesignation || prev.alp_crew_designation,
        alp_crew_name: data.alp || prev.alp_crew_name,
      }));
    }
    if (label === "redmarkDeficiency") {
      setFullFormData((prev) => ({
        ...prev,
        deficiency: data.deficiency || prev.deficiency,
        remark: data.remark || prev.remark,
      }));
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await apiService(
        "PUT",
        RAILWAY_CONST.API_ENDPOINT.REPORTS,
        fullFormData
      );
      navigate(RAILWAY_CONST.ROUTE.DASHBOARD);
    } catch (error) {
      let errorMessage = "Something went wrong. Please try again.";
      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="loaderingView">
          <div className="loaderPdf">
            <div className="loader">
              <Loader />
            </div>
          </div>
        </div>
      )}
      <div
        ref={contentRef}
        className="w-full bg-[#efefef] p-4 reportGenerateBg reportGenerateMain pt-8 min-h-screen"
      >
        <div id="pdf-first-part">
          <Suspense
            fallback={
              <div className="loader">
                <Loader />
              </div>
            }
          >
            {currentReport && (
              <ReportTable
                onFormChange={handleFormChange}
                handleHaltSelectedData={handleHaltSelectedData}
                handleDownloadPDF={handleDownloadPDF}
                handleformData={handleformData}
                currentReport={currentReport}
              />
            )}
          </Suspense>

          {/* {currentReport.speed_before_1000m ? (
            <div className="max-w-full mx-auto px-2 mb-4">
              <div className="bg-white w-full p-8 pt-2 rounded-[15px]">
                <Suspense fallback={<div>Loading table...</div>}>
                  <TableComponent
                    data={halteTable.data}
                    colums={halteTable.columns}
                    tableTitle={"Speed From 1000 m in rear of halts"}
                  />
                </Suspense>
              </div>
            </div>
          ) : null} */}

          <div className="max-w-full mx-auto sm:px-2 px-0 mb-4">
            <div className="bg-white w-full sm:p-8 p-4 pt-2 rounded-[15px]">
              {halteTable?.data && halteTable?.data?.length > 0 ? (
                <Suspense fallback={<div>Loading table...</div>}>
                  <TableComponent
                    data={halteTable.data}
                    colums={halteTable.columns}
                    tableTitle={"Speed from 2200 m in rear of halts"}
                  />
                </Suspense>
              ) : (
                <>
                  <TableComponent
                    tableTitle={"Speed from 2200 m in rear of halts"}
                  />
                  <p className="text-gray-500 text-center">No records of halts are available</p>
                </>
              )}
            </div>
          </div>

          {chartSpeedBeforHaltData && halteTable?.data && halteTable?.data?.length > 0 ? (
            <div className="max-w-full mx-auto sm:px-2 px-0 mb-4">
              <div className="bg-white w-full sm:p-8 p-4 pt-2 rounded-[15px]">
                {loading ? (
                  <div className="componentLoader">
                    <Loader />
                  </div>
                ) : (
                  <div style={{ overflowX: "auto", width: "100%" }}>
                    <ChartComponent
                      loading={loading}
                      chartData={chartSpeedBeforHaltData}
                    />

                  </div>
                )}
              </div>
            </div>
          ) : null}

          {/* <div className="max-w-full mx-auto sm:px-2 px-0 mb-4">
            <div className="bg-white w-full sm:p-8 p-4 pt-2 rounded-[15px]">
              <Suspense fallback={<div>Loading table...</div>}>
                <TableComponent
                  data={halteTableAfter.data}
                  colums={halteTableAfter.columns}
                  tableTitle={"Speed to 1800 m in rear of halts"}
                />
              </Suspense>
            </div>
          </div> */}


        </div>
        <div id="pdf-speed-graph">
          {/* <div className="max-w-full mx-auto px-0 mb-4">
            <div className="bg-white w-full sm:p-8 p-2 sm:pb-16 pb-4 rounded-[15px]">
              <Suspense
                fallback={
                  <div className="loader">
                    <Loader />
                  </div>
                }
              >
                <SpeedGraphComponent
                  haltStation={haltStation}
                  speed_before_1000m={currentReport.speed_before_1000m}
                />
              </Suspense>
            </div>
          </div> */}
          <div className="max-w-full mx-auto sm:px-2 px-0 mb-4">
            <div className="bg-white w-full sm:p-8 p-4 pt-2 rounded-[15px]">
              {halteTableAfter?.data && halteTableAfter?.data?.length > 0 ? (
                <Suspense fallback={<div>Loading table...</div>}>
                  <TableComponent
                    data={halteTableAfter.data}
                    colums={halteTableAfter.columns}
                    tableTitle={"Speed After Starting From Halt"}
                  />
                </Suspense>
              ) : (
                <>
                  <TableComponent
                    tableTitle={"Speed After Starting From Halt"}
                  />
                  <p className="text-gray-500 text-center">No records of halts are available</p>
                </>
              )}
            </div>
          </div>



          {chartSpeedAfterHaltData && halteTableAfter?.data && halteTableAfter?.data?.length > 0 ? (
            <div className="max-w-full mx-auto sm:px-2 px-0 mb-4">
              <div className="bg-white w-full sm:p-8 p-4 pt-2 rounded-[15px]">
                {loading ? (
                  <div className="componentLoader">
                    {/* <Loader /> */}
                  </div>
                ) : (
                  <div style={{ overflowX: "auto", width: "100%" }}>
                    <ChartComponent
                      loading={loading}
                      chartData={chartSpeedAfterHaltData}
                    />

                  </div>
                )}
              </div>
            </div>) : null}

          <div className="max-w-full mx-auto px-0 mb-4">
            <div className="bg-white w-full sm:p-8 p-2 sm:pb-16 pb-4 rounded-[15px]">
              <Suspense
                fallback={
                  <div className="loader">
                    <Loader />
                  </div>
                }
              >
                {currentReport && (
                  <SpeedGraphComponent
                    haltStation={haltStation}
                    speed_before_1000m={currentReport?.speed_before_1000m}
                  />
                )}
              </Suspense>

            </div>
          </div>

          <div className="max-w-full mx-auto px-2 mb-4">
            <div className="bg-white w-full  sm:p-8 p-2 pb-16 rounded-[15px]">
              <Suspense fallback={<div>Loading deficiency remarks...</div>}>
                {currentReport && (
                  <DeficiencyRemark
                    handleformData={handleformData}
                    deficiency={currentReport.deficiency}
                    remark={currentReport.remark}
                  />
                )}
              </Suspense>
              <div className="w-full justify-center items-center flex">
                <button
                  id="submitButon"
                  className="px-4 reportGenerateBg bg-blue-600 text-white rounded hover:bg-blue-700 py-1 inline-block"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        {showUploadBox && (
          <Suspense
            fallback={
              <Suspense fallback={<Loader />}>
                <Loader />
              </Suspense>
            }
          >
            <UploadFilePopup onClose={() => setShowUploadBox(false)} />
          </Suspense>
        )}
        {popup.show && (
          <ShowMessagePopUp
            message={popup.message}
            type={popup.type}
            onClose={() => setPopup({ show: false, message: "", type: "" })}
          />
        )}
      </div>
    </>
  );
};

export default ReportGenerateComponent;
